<template>
  <div>
    <highlight-filter
      :getFilterOnStart="true"
      :is_customer_page="true"
      @filterChange="changeFilter"
    ></highlight-filter>

    <!-- Stats Start -->
    <div class="row">
      <div class="col-md-6 mt-4">
        <highlight-stats-customer
          id="1"
          title="Total Scan Product"
          description="Total botol oli yang di scan oleh customer"
          :value="data.stats ? data.stats.scan : null"
        ></highlight-stats-customer>
      </div>
      <div class="col-md-6 mt-4">
        <highlight-stats-customer
          id="2"
          title="Total Report Customer"
          description="Total laporan produk oleh customer"
          :value="data.stats ? data.stats.report : null"
        ></highlight-stats-customer>
      </div>
      <div class="col-md-4 mt-4">
        <highlight-stats-customer
          id="3"
          title="Valid Product"
          description="Total product yang valid (Berhasil di scan oleh customer)"
          :value="data.stats ? data.stats.valid : null"
        ></highlight-stats-customer>
      </div>
      <div class="col-md-4 mt-4">
        <highlight-stats-customer
          id="4"
          title="Inactive Product"
          description="Qr inactive yang di scan oleh customer"
          :value="data.stats ? data.stats.invalid : null"
        ></highlight-stats-customer>
      </div>
      <div class="col-md-4 mt-4">
        <highlight-stats-customer
          id="5"
          title="Expired Product"
          description="Total product yang sudah habis masa berlaku (3 Tahun)"
          :value="data.stats ? data.stats.expired : null"
        ></highlight-stats-customer>
      </div>
    </div>
    <!-- Stats End -->

    <div class="row">
      <div class="col-md-6 mt-4">
        <div class="innerBox chart h-100">
          <h5 class="elegant--sub-title">
            Most Reason Report
            <!-- <i
                            class="far fa-info-circle"
                            :id="'LabelMakerInfo'"
                        ></i>
                        <b-popover target="LabelMakerInfo" triggers="hover" placement="top">
                          <template #title>QR Active By Label Maker</template>
                            {{tooltip.qr_active_by_label_maker}}
                        </b-popover> -->
          </h5>
          <div class="chart-container">
            <customer-most-reason-report
              v-if="data.mostReasonReport"
              :chartData="data.mostReasonReport"
              :filter="filter"
            ></customer-most-reason-report>
            <div v-else class="text-center mt-5 mb-5">
              <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-4">
        <div class="innerBox chart h-100">
          <h5 class="elegant--sub-title">
            Most Variant Report
            <!-- <i
                            class="far fa-info-circle"
                            :id="'LabelMakerInfo'"
                        ></i>
                        <b-popover target="LabelMakerInfo" triggers="hover" placement="top">
                          <template #title>QR Active By Label Maker</template>
                            {{tooltip.qr_active_by_label_maker}}
                        </b-popover> -->
          </h5>
          <div class="chart-container">
            <customer-most-variant-report
              v-if="data.mostVariantReport"
              :chartData="data.mostVariantReport"
              :filter="filter"
            ></customer-most-variant-report>
            <div v-else class="text-center mt-5 mb-5">
              <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Reasons for Report Start -->
    <div class="innerBox mt-4">
      <h5 class="elegant--sub-title">
        Reasons for Report
        <i class="fal fa-info-circle" id="reasons-for-report"></i>
        <b-popover target="reasons-for-report" triggers="hover" placement="top">
          <template #title>Reasons for Report</template>
          <div v-html="tooltip.reasons_for_report"></div>
        </b-popover>
      </h5>
      <div class="chart-container">
        <reasons-for-report
          v-if="data.reasonsForReport != null"
          :data="data.reasonsForReport"
        ></reasons-for-report>
        <div v-else class="text-center mt-5 mb-5">
          <h2 class="pt-5 pb-5">Loading...</h2>
        </div>
      </div>
    </div>
    <!-- Reasons for Report End -->

    <!-- Scan vs Report Start -->
    <!-- <div class="innerBox mt-4">
      <h5 class="elegant--sub-title">
        Scan vs Report
        <i class="far fa-info-circle" id="scan-vs-report"></i>
        <b-popover target="scan-vs-report" triggers="hover" placement="top">
          <template #title>Scan Vs Report</template>
          <div v-html="tooltip.scan_vs_report"></div>
        </b-popover>
      </h5>
      <scan-vs-report v-if="data.scanVsReport != null" :data="data.scanVsReport" :filter="filter"></scan-vs-report>
      <div v-else class="text-center mt-5 mb-5">
        <h2 class="pt-5 pb-5">Loading...</h2>
      </div>
    </div> -->
    <!-- Scan vs Report End -->
  </div>
</template>

<script>
import qs from "qs";

import highlightFilter from "@/components/filter/highlightFilter";
import highlightStatsCustomer from "./children/HighlightStatsCustomer";

import reasonsForReport from "./children/reasonsForReportBarChart";
import scanVsReport from "./children/scanVsReportBarChart";
import CustomerMostReasonReport from "./children/CustomerMostReasonReport.vue";
import CustomerMostVariantReport from "./children/CustomerMostVariantReport.vue";

export default {
  metaInfo: {
    title: "Highlight - Customer",
  },
  data() {
    return {
      tooltip: this.$store.state.tooltip.highlight.customer,
      filter: {},
      data: {
        stats: {
          scan: null,
          report: null,
          valid: null,
          invalid: null,
          expired: null,
        },
        reasonsForReport: null,
        mostReasonReport: null,
        mostVariantReport: null,
      },
    };
  },
  components: {
    highlightFilter,
    highlightStatsCustomer,

    reasonsForReport,
    scanVsReport,
    CustomerMostReasonReport,
    CustomerMostVariantReport,
  },
  // mounted() {
  //   this.fetchData();
  // },
  watch: {
    filter: {
      deep: true,
      handler: "fetchData",
    },
  },
  methods: {
    changeFilter(filter) {
      let newFilter = {};

      for (var i in filter) newFilter[i] = filter[i];

      this.filter = structuredClone(newFilter);
      this.vue_universal_table.filter = structuredClone(newFilter);

      //Delete unnecessary filter for the table
      delete this.vue_universal_table.filter.filter;
      // console.log('%cHighlightLabelMaker.vue line:262 filter', 'color: #007acc;', filter);
      // this.fetchData();
      this.vue_universal_table.update++;
    },
    fetchData() {
      //Reset All Data to null
      for (var i in this.data) this.data[i] = null;

      //Remove filter from filter
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      delete filterlessFilter.filter;

      //Stats
      this.$http
        .get(
          `/api/highlight/customer-variant-overview?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          let data = resp.data.data;
          for (var i in data) data[i] = data[i] ? data[i] : 0;
          this.data.stats = data;
        })
        .catch((err) => {
          console.log(err);
        });

      // Most Reason Report
      this.$http
        .get(
          `/api/highlight/most-reason-report?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.mostReasonReport = resp.data.data;
        })
        .catch((err) => {
          console.error("Error fetching Most Reason Report:", err);
        });

      // Most Variant Report
      this.$http
        .get(
          `/api/highlight/most-variant-report?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.mostVariantReport = resp.data.data;
        })
        .catch((err) => {
          console.error("Error fetching Most Variant Report:", err);
        });

      //Reasons for Report
      this.$http
        .get(
          `/api/highlight/report-reason-overview?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.reasonsForReport = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
        });

      //Scan Vs Report
      // this.$http
      //   .get(
      //     `/api/highlight/scan-report-overview?${qs.stringify(this.filter, {
      //       skipNulls: true,
      //       arrayFormat: "comma",
      //     })}`
      //   )
      //   .then((resp) => {
      //     this.data.scanVsReport = resp.data.data;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  /* padding: 20px; */
}

.innerBox h5 {
  padding: 20px;
}

.chart h5 {
  height: 10%;
  margin-bottom: 0;
}

.chart-container {
  height: 90%;
}
</style>
